import * as v from "valibot";
import { defineValidation } from "../../common/validation.common";

export namespace FeatureTogglesValidation {
    export const Data = defineValidation(v.record(v.string(), v.boolean()));
}
